import { selectAppConfig } from "./selectAppConfig";

export const selectShowCalculatorDisclimer = state => {
  const appConfig = selectAppConfig(state);

  return !!(appConfig.blocks && appConfig.blocks.calculator && appConfig.blocks.calculator.show_calculator_disclaimer);
}
